package ui.widget

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.mohamedrejeb.richeditor.ui.material3.RichText
import compose.assets.Svg
import compose.assets.svg.Chat_question
import org.jetbrains.compose.resources.StringResource
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.dialog__action_ok
import tools.rememberRichTextState
import tools.rememberString

@Composable
fun TooltipDialog(
    state: DialogState,
    title: StringResource,
    message: StringResource
) {
    Dialog(state) {
        DialogUI(
            modifier = Modifier,
            onDismissRequest = { state.hide() },
            icon = { Icon(Svg.Chat_question, null) },
            title = { Text(title.rememberString()) },
            confirmButton = {
                TextButton({ state.hide() }) {
                    Text(Res.string.dialog__action_ok.rememberString())
                }
            }
        ) {
            val scroll = rememberScrollState()
            Box(
                Modifier.fillMaxWidth()
                    .verticalScroll(scroll)
            ) {
                RichText(
                    state = rememberRichTextState(message),
                    modifier = Modifier.wrapContentHeight(Alignment.Top)
                )
            }
        }
    }
}